import { requireStates } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";

const initialStates = [
  {
    name: "app.my-account",
    url: "/minha-conta",
    abstract: true,
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    },
    data: {
      navigation: {
        priority: 500,
        name: "Minha Conta",
        children: [
          {
            priority: 100,
            authorization: context =>
              context.user.permissions.includes("manage_own_profile"),
            name: "Alterar Dados Pessoais",
            state: "app.registration.user.info",
            stateParams: { userUuid: "minha-conta" }
          },
          {
            priority: 200,
            authorization: context =>
              context.user.permissions.includes("manage_own_company"),
            name: "Minha Empresa",
            state: "app.registration.company.view",
            stateParams: { companyUuid: "minha-empresa" }
          }
          // {
          //   priority: 300,
          //   authorization: () => true,
          //   name: 'Cobrança',
          //   state: 'app.billing',
          // },
        ]
      },
      authorization: context =>
        context.user.permissions.includes("manage_own_company") ||
        context.user.permissions.includes("manage_own_profile")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/my-account/index.js